(() => {
  const trigger = document.querySelector('.pc-footer__cookie-settings');
  if (!trigger) return;

  trigger.onclick = () => {
    window.setTimeout(() => {
      if (document.getElementById('Avada-CookiesBar')) return;

      const resetConsent = {
        marketing: false,
        analytics: false,
        functional: false,
        preferences: false,
        sale_of_data: false,
        hasActionOnBanner: false,
        newRecord: false,
        resetAt: new Date().toISOString()
      };

      document.cookie = `avada_cookie_consent=${encodeURIComponent(JSON.stringify(resetConsent))}; path=/; max-age=31536000; SameSite=Lax`;

      let reloading = false;
      const reload = () => {
        if (reloading) return;
        reloading = true;
        window.location.reload();
      };
      const customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;

      if (customerPrivacy && typeof customerPrivacy.setTrackingConsent === 'function') {
        customerPrivacy.setTrackingConsent(
          { analytics: false, marketing: false, preferences: false, sale_of_data: false },
          reload
        );
        window.setTimeout(reload, 1500);
      } else {
        reload();
      }
    }, 1500);
  };
})();
